export enum PostFilterBy {
  POPULARITY = 'popular',
  RECENT = 'recent',
}
